function detectCourier(trackingNumber) {
    // Remove whitespace and convert to uppercase for comparison
    var cleanNumber = trackingNumber.trim().toUpperCase();
    
    // // Professional Courier: Starts with VPL (case insensitive)
    if (cleanNumber.startsWith('VPL')) {
        return {
            type: 'professional',
            name: 'Professional Courier',
            //iframeUrl: 'https://t.17track.net/en#nums=' + encodeURIComponent(trackingNumber)+'&fc=100279',
            iframeUrl: 'https://trackcourier.io/track-and-trace/professional-courier/'+ encodeURIComponent(trackingNumber),
            directUrl: 'https://www.tpcindia.com'
        };
    }
    
    // Trackon Courier: Starts with 100
    if (cleanNumber.startsWith('100')) {
        return {
            type: 'trackon',
            name: 'Trackon Courier',
            iframeUrl: 'https://t.17track.net/en#nums=' + encodeURIComponent(trackingNumber)+'&fc=100180',
            directUrl: 'https://www.trackon.in/'
        };
    }
    
    // IndiaPost Courier: Ends with IN
    if (cleanNumber.endsWith('IN')) {
        return {
            type: 'indiapost',
            name: 'India Post',
            iframeUrl: 'https://t.17track.net/en#nums=' + encodeURIComponent(trackingNumber)+'&fc=9021',
            directUrl: 'https://www.indiapost.gov.in/'
        };
    }
	
    // Delhivery Courier India
	if (cleanNumber.startsWith('5033')) {
        return {
            type: 'Delhivery',
            name: 'Delhivery India',
            //iframeUrl: 'https://t.17track.net/en#nums=' + encodeURIComponent(trackingNumber) + '&fc=100060&sc=0&params_v2=' + encodeURIComponent(JSON.stringify({ number_type: '1' })),
            iframeUrl: 'https://trackcourier.io/track-and-trace/delhivery-courier/'+ encodeURIComponent(trackingNumber),
            directUrl: 'https://www.delhivery.com/'
        };
    }
    
	// DTDC Courier India
	const validTrackInput = /^[a-zA-Z0-9,\s]+$/;
    if (validTrackInput.test(trackingNumber) && (trackingNumber.startsWith("7") && trackingNumber.length < 12)) {
        return {
            type: 'DTDC',
            name: 'DTDC India',
            // iframeUrl: 'https://t.17track.net/en#nums=' + encodeURIComponent(trackingNumber)+'&fc=100069',
            iframeUrl: 'https://www.dtdc.com/track-your-shipment/?awb=' + encodeURIComponent(trackingNumber),
            directUrl: 'https://www.dtdc.com/'
            // directUrl: 'https://txk.dtdc.com/ctbs-tracking/customerInterface.tr?submitName=showCITrackingDetails&cType=Consignment&cnNo='+ encodeURIComponent(trackingNumber)
        };
    }

    // Anjani Courier: Everything else (default)
    return {
        type: 'anjani',
        name: 'Anjani Courier',
        iframeUrl: 'https://shreeanjani.co.in/tracking/?awb=' + encodeURIComponent(trackingNumber),
        // iframeUrl: 'https://t.17track.net/en#nums=' + encodeURIComponent(trackingNumber)+'&fc=100530',
        // directUrl: 'http://anjanicourier.in/Doc_Track.aspx?No=' + encodeURIComponent(trackingNumber)
        directUrl: 'https://shreeanjani.co.in/'
    };
}

function trackOrder() {
    var trackingNum = document.getElementById("trackingNumber").value.trim();
    
    if(trackingNum === ""){
        alert("Please enter your tracking number."); 
        return;
    }
    
    // Auto-detect courier based on tracking number
    var courier = detectCourier(trackingNum);
    
    var resultsDiv = document.getElementById("trackingResults");
    var courierInfoDiv = document.getElementById("courierInfo");
    
    // Show detected courier info (optional - remove if you don't want to show this)
    courierInfoDiv.innerHTML = 'Detected: ' + courier.name;
    
    // Show loading state
    resultsDiv.innerHTML = '<div style="text-align: center; padding: 30px;"><p style="color: #666;">Loading tracking information...</p></div>';
    
    // Create embedded tracking display
    var html = '<div style="max-width: 1000px; margin: 0 auto;">';
    html += '<div style="background: #f5f5f5; padding: 20px; border-radius: 8px 8px 0 0; text-align: center;">';
    html += '<h3 style="margin: 0 0 10px 0; color: #333; font-size: 20px;">' + courier.name + '</h3>';
    html += '<p style="margin: 0; color: #666; font-size: 14px;">Tracking Number: <strong style="color: #333;">' + trackingNum + '</strong></p>';
    html += '</div>';
    
    html += '<iframe src="' + courier.iframeUrl + '" ';
    html += 'style="width: 100%; height: 600px; border: 1px solid #ddd; border-top: none; border-radius: 0 0 8px 8px; display: block;" ';
    html += 'frameborder="0" scrolling="auto"></iframe>';
    
    html += '<div style="text-align: center; margin-top: 20px; padding-bottom: 40px;">';
    html += '<a href="' + courier.directUrl + '" target="_blank" ';
    html += 'style="color: #333; text-decoration: underline; font-size: 14px; transition: color 0.2s;">View on Official ' + courier.name + ' Website →</a>';
    html += '</div>';
    html += '</div>';
    
    resultsDiv.innerHTML = html;
}

// Allow Enter key to trigger tracking
document.addEventListener('DOMContentLoaded', function() {
    var input = document.getElementById("trackingNumber");
    if(input) {
        input.addEventListener('keypress', function(e) {
            if(e.key === 'Enter') {
                trackOrder();
            }
        });
    }
});